export default __webpack_public_path__ + "static/media/crm.8c150f7f.jpeg";